<template>
    <div class="div-calculator">
        <div v-for="(c, i) in grouped_components.filter(comp => !comp.omit_in_composition)"
             v-if="(c.name + c.cas_number).trim().toLowerCase().includes(name.trim().toLowerCase())"
             class="mb-2"
        >
            <b-row>
                <b-col>
                    <span class="font-weight-bold">
                        <b-badge variant="success"
                                 class="mr-1"
                                 style="width: 90px"
                        >
                            {{ c.cas_number }}
                        </b-badge>
                        {{ c.name }}
                    </span>
                    <span class="font-weight-bold float-right">
                        <b-badge variant="primary"
                                 style="width: 90px"
                        >
                            {{
                                Math.round(c.final_percentage * 10000) / 10000
                            }}%
                        </b-badge>
                    </span>
                    <hr class="mt-1 mb-2">
                </b-col>
            </b-row>

            <form @submit.prevent="saveAll()"
                  :data-vv-scope="'toxicity' + i"
            >
                <b-row>
                    <b-col md
                           cols="12"
                    >
                        <label for="cl_50_fish">
                            PECES (DL50) <span class="text-black-50 small">(mg/l)</span>
                            <validation_tooltip
                                field="cl_50_fish"
                                :value="c"
                            />
                        </label>
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <el-tooltip effect="dark"
                                            placement="top"
                                            popper-class="py-1 px-2"
                                >
                                    <div slot="content">
                                        Marque esta casilla si sabe que este componente NO <br/>
                                        presenta toxicidad al medio ambiente a corto plazo
                                    </div>
                                    <b-form-checkbox v-model="c.toxicity.add_cl_50_fish"
                                                     :unchecked-value="0"
                                                     :value="1"
                                                     @change="setChanged(c)"
                                                     :disabled="only_view"
                                    />
                                </el-tooltip>
                            </b-input-group-prepend>
                            <b-form-input :id="'cl_50_fish_' + i"
                                          :name="'cl_50_fish_' + i"
                                          size="sm"
                                          type="number"
                                          v-model="c.toxicity.cl_50_fish"
                                          data-vv-as=" "
                                          v-validate="'decimal:7|min_value:0|max_value:100000'"
                                          @change="setChanged(c)"
                            ></b-form-input>
                        </b-input-group>
                        <span class="text-danger small"
                              v-text="errors.first('toxicity' + i + '.cl_50_fish_' + i)"
                        />
                    </b-col>

                    <b-col md
                           cols="12"
                    >
                        <label for="ce_50_crustaceans">
                            CRUSTÁCEOS (CE50) <span class="text-black-50 small">(mg/l)</span>
                            <validation_tooltip
                                field="ce_50_crustaceans"
                                :value="c"
                            />
                        </label>
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <el-tooltip effect="dark"
                                            placement="top"
                                            popper-class="py-1 px-2"
                                >
                                    <div slot="content">
                                        Marque esta casilla si sabe que este componente NO <br/>
                                        presenta toxicidad al medio ambiente a corto plazo
                                    </div>
                                    <b-form-checkbox v-model="c.toxicity.add_ce_50_crustaceans"
                                                     :unchecked-value="0"
                                                     :value="1"
                                                     @change="setChanged(c)"
                                                     :disabled="only_view"
                                    />
                                </el-tooltip>
                            </b-input-group-prepend>
                            <b-form-input :id="'ce_50_crustaceans_' + i"
                                          :name="'ce_50_crustaceans_' + i"
                                          size="sm"
                                          type="number"
                                          v-model="c.toxicity.ce_50_crustaceans"
                                          data-vv-as=" "
                                          v-validate="'decimal:7|min_value:0|max_value:100000'"
                                          @change="setChanged(c)"
                            ></b-form-input>
                        </b-input-group>
                        <span class="text-danger small"
                              v-text="errors.first('toxicity' + i + '.ce_50_crustaceans_' + i)"
                        />
                    </b-col>

                    <b-col md
                           cols="12"
                    >
                        <label for="cer_50_algae">
                            ALGAS (CEr50) <span class="text-black-50 small">(mg/l)</span>
                            <validation_tooltip
                                field="cer_50_algae"
                                :value="c"
                            />
                        </label>
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <el-tooltip effect="dark"
                                            placement="top"
                                            popper-class="py-1 px-2"
                                >
                                    <div slot="content">
                                        Marque esta casilla si sabe que este componente NO <br/>
                                        presenta toxicidad al medio ambiente a corto plazo
                                    </div>
                                    <b-form-checkbox v-model="c.toxicity.add_cer_50_algae"
                                                     :unchecked-value="0"
                                                     :value="1"
                                                     @change="setChanged(c)"
                                                     :disabled="only_view"
                                    />
                                </el-tooltip>
                            </b-input-group-prepend>
                            <b-form-input :id="'cer_50_algae_' + i"
                                          :name="'cer_50_algae_' + i"
                                          size="sm"
                                          type="number"
                                          v-model="c.toxicity.cer_50_algae"
                                          data-vv-as=" "
                                          v-validate="'decimal:7|min_value:0|max_value:100000'"
                                          @change="setChanged(c)"
                            ></b-form-input>
                        </b-input-group>
                        <span class="text-danger small"
                              v-text="errors.first('toxicity' + i + '.cer_50_algae_' + i)"
                        />
                    </b-col>
                </b-row>
            </form>
        </div>

        <b-row>
            <b-col cols="12"
                   class="text-center mb-2 mt-1"
            >
                <b-btn variant="success"
                       :disabled="!grouped_components.some(c => c.changed)"
                       size="sm"
                       @click="saveAll()"
                >
                    <i class="fa fa-save"/>
                    <span v-if="grouped_components.some(c => c.changed)">
                        Guardar <b-badge variant="light"> {{ grouped_components.filter(comp => comp.changed).length }}</b-badge> componente(s)
                    </span>
                    <span v-else>
                        Guardar componentes
                    </span>
                </b-btn>
            </b-col>
        </b-row>
    </div>
</template>

<script>

import {mapActions, mapMutations, mapState} from 'vuex';
import validation_tooltip from "../../../../components/validation_tooltip.vue";

export default {
    name: 'index',
    components: {validation_tooltip},
    props: {
        name: {
            required: true,
            default: ''
        }
    },
    computed: {
        ...mapState('calculator', [
            'measure_units_cl_50',
            'grouped_components',
            'classification',
            'only_view',
            'product',
            'totals'
        ])
    },
    methods: {
        ...mapActions('calculator', [
            'downloadClassificationAcuteToxicity',
            'getGroupedComponents',
            'updateToxicitiesComponents',
            'getClassification'
        ]),
        ...mapMutations('calculator', [
            'setGroupedComponents',
            'setModalToxicityShow'
        ]),
        async saveAll() {
            let valid = await this.validate();

            if (valid) {
                let components = this.grouped_components.filter(c => c.changed);

                await this.updateToxicitiesComponents({components});

                this.$emit('getClassification');
            }
        },
        async validate(index = 0) {
            if (index >= this.grouped_components.length) {
                return true;
            }

            let valid = true;
            let second_valid = true;
            let component = this.grouped_components[index];

            if (component.changed){
                valid = await this.$validator.validateAll('toxicity' + index);
            }

            second_valid = await this.validate(index + 1);

            return valid && second_valid;
        },
        setChanged(component_product, changed = true) {
            const updatedComponents = this.grouped_components.map(gc =>
                gc.id === component_product.id ? {...gc, changed} : gc
            );
            this.setGroupedComponents(updatedComponents);
        }
    }
};
</script>
